import CaregiverFormFlow from '../components/CaregiverFormFlow';

export default function Application() {
  return <CaregiverFormFlow kind="application" />;
}
